import * as React from 'react';
import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

export interface InputBaseTileProps extends React.HTMLAttributes<HTMLInputElement> {
  value?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  autoComplete?: 'none' | 'on';
  maxLength?: number;
  pattern?: string;
  type?: string;
}

const StyledInputBaseTile = styled('input')<InputBaseTileProps>`
  background-color: ${themeGet('colors.gray-800')};
  color: ${themeGet('colors.white')};
  border-radius: 6px;
  padding: ${themeGet('space.3')};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  outline: none;
  appearance: none;
  margin: 0;
  border: 0;
  line-height: 1;
  text-decoration: none;
  font-family: ${themeGet('fontFamily.sans-serif')};
  font-weight: ${themeGet('fontWeights.bold')};
  font-size: ${themeGet('fontSizes.text-xxl')};

  @media only screen and (max-width: ${themeGet('breakpoints.1')}) {
    font-size: ${themeGet('fontSizes.text-l')};
  }

  &:disabled {
    background-color: ${themeGet('colors.gray-800')};
    color: ${themeGet('colors.gray-600')};
  }
`;

// The generic might looks like it's inverted but it's not.
// React.forwardRef is a generic function that is declared <T, P> as <T> for ref and <P> for props.
// while it's the opposite ordering for the function parameters declared as <P, T>
const InputBaseTile = React.forwardRef<HTMLInputElement, InputBaseTileProps>((props, ref) => {
  return (
    <StyledInputBaseTile ref={ref} {...props}>
      {props.children}
    </StyledInputBaseTile>
  );
});

export { InputBaseTile };
